import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BenefitSummaryList } from 'src/app/models/benefit-summary';

@Component({
    selector: 'mwp-current-deductions',
    templateUrl: 'current-deductions.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CurrentDeductionsComponent implements OnInit {
    @Input() public currentBenefits: BenefitSummaryList;

    constructor(
    ) {
    }

    ngOnInit() {
    }
}